export const ROUTER_PATH = {
  MyCard: "/",
  AddCard: "/AddCard",
  NameCard: "/NameCard",
};
